import axios from 'axios'
import axiosInstance from './axiosInstance'
import axiosMedia from './axiosInstance'
import { URL } from '../constants'
import { Interlocutor } from '../pages/Сhat/ChatUsersBox'

export interface ChatsAPIType {
  chat_id: number
  interlocutor: Interlocutor
  last_message: {
    message: string
    created_at: string
  }
  number_of_unread_messages: number
}

// leads page
export const getLeadsInWork = () =>
  axiosInstance.get('/dashboard/companies/leads/in-work').then(res => res.data)

export const getLeadsAvailable = () =>
  axiosInstance
    .get('/dashboard/companies/leads/available')
    .then(res => res.data)

export const getLeadsCompleted = () =>
  axiosInstance
    .get('/dashboard/companies/leads/completed')
    .then(res => res.data)

export const getCompaniesDashboard = () =>
  axiosInstance.get('/dashboard/companies/dashboard').then(res => res.data)

// Auth
export const sendAuth = (data: { email: string; password: string }) =>
  axios.post(URL + '/dashboard/auth/login', data)

export const refreshToken = () =>
  axiosInstance.post('/dashboard/auth/refresh').then(res => res.data)

export const authLogout = () =>
  axiosInstance.post('/dashboard/auth/logout').then(res => res.data)

export const sendSignup = (data: {
  username: string
  email: string
  password: string
  /* icon: string, */ rules: boolean
}) => axios.post(URL + '/dashboard/clients/sign-up', data)

export const sendMedia = (data: FormData) => axiosMedia.post('/medias', data)

// Chat
export const getChats = () => axiosInstance.get('/dashboard/chats')

export const getChatMessage = (chat_id: number, query: string): Promise<any> =>
  axiosInstance
    .get(`/dashboard/chats/${chat_id}?${query}`)
    .then(resp => resp.data.data)

export const sendMessages = ({
  chat_id,
  message,
}: {
  chat_id: number
  message: string
}) =>
  axiosInstance.post('/dashboard/chats/send-message', {
    chat_id,
    message,
  })

export const sendInitMessage = (data: {
  recipient_id: number
  message: string
}) =>
  axiosInstance
    .post('/dashboard/chats/send-init-message', data)
    .catch(error =>
      error.response.status === 500 ? error.response.data : error,
    )

export const markMessages = (chat_id: number) =>
  axiosInstance.post(`/dashboard/chats/mark-messages/${chat_id}`, { chat_id })

// Client
export const getSearch = () => axiosInstance.get('/dashboard/clients/search')

// export const getLeads = () => {
//   console.log();
//   return axios.get('/dashboard/companies/leads/available')
// }

// export const sendPhone = (data: { phone: string }) =>
//   axios.post('/auth/login-phone-start', data)

// export const getCommunitiesCategory = (id: string, params?: string) =>
//   axios.get(`/communities/${id}/categories?${params}`)
